<!-- lead-view.component.html -->
<div class="container-fluid py-3">
  <div class="d-flex justify-content-center">
    <ul class="nav nav-tabs">
      <li class="nav-item">
        <a class="nav-link optionone" 
           [ngClass]="{'active': activeTab === 'details'}" 
           (click)="setActiveTab('details')" 
           href="javascript:void(0)">
          View Details
        </a>
      </li>
      <li class="nav-item">
        <a class="nav-link optiontwo" 
           [ngClass]="{'active': activeTab === 'timeline'}" 
           (click)="setActiveTab('timeline')" 
           href="javascript:void(0)">
          Timeline Notes
        </a>
      </li>
    </ul>
  </div>
  
      
  
    <div class="row">
      <div class="col-12">
        <div class="tab-content">
          <div class="tab-pane fade" [ngClass]="{'show active': activeTab === 'details'}">
            <div *ngIf="activeTab === 'details'">
              <div class="container-fluid mb-4">
                <div class="row mb-3">
                  <div class="col">
                    <h5 class="lead-title">
                      Lead {{ lead?.category?.toLowerCase() === 'entity' ? 'Entity' : 'Lawyer' }} -
                      {{ lead?.category?.toLowerCase() === 'entity' ? lead?.name : lead?.fullname }}
                    </h5>
                    
                  </div>
                  <div class="col text-end">
                    <button *ngIf="!editMode" class="btn btn-primary btn-sm" (click)="toggleEditMode()">
                      <i class="bi bi-pencil-square"></i> Edit Details
                    </button>
                  </div>
                </div>
  
                <form [formGroup]="leadForm">
                  <div class="row">
                    <!-- Left Column -->
                    <div class="col-md-6">
                      <div class="mb-3" *ngIf="lead.category.toLowerCase() !== 'entity'">
                        <label class="form-label fw-bold">Name <span class="text-danger">*</span></label>
                        <div *ngIf="!editMode" class="form-control-static">{{ lead?.fullname }}</div>
                        <input *ngIf="editMode" type="text" class="form-control" formControlName="fullname"
                        (input)="removeLeadingSpace($event)" autocomplete="off" autocorrect="off">
                        <div *ngIf="editMode && leadForm.get('fullname')?.invalid && leadForm.get('fullname')?.touched" class="text-danger small">
                          Name is required
                        </div>
                      </div>

                      <div class="mb-3" *ngIf="lead.category === 'entity'">
                        <label class="form-label fw-bold">Firm Name <span class="text-danger">*</span></label>
                        <div *ngIf="!editMode" class="form-control-static">{{ lead?.name }}</div>
                        <input *ngIf="editMode" type="text" class="form-control" formControlName="name"
                        (input)="removeLeadingSpace($event)" autocomplete="off" autocorrect="off">
                        <div *ngIf="editMode && leadForm.get('name')?.invalid && leadForm.get('name')?.touched" class="text-danger small">
                          Name is required
                        </div>
                      </div>
  
                      <div class="mb-3">
                        <label class="form-label fw-bold" *ngIf="lead.category.toLowerCase() === 'entity'">Firm Email <span class="text-danger">*</span></label>
                        <label class="form-label fw-bold" *ngIf="lead.category.toLowerCase() !== 'entity'">Email <span class="text-danger">*</span></label>
                        <div *ngIf="!editMode" class="form-control-static">{{ lead?.email }}</div>
                        <input *ngIf="editMode" type="email" class="form-control" formControlName="email"
                        (input)="removeLeadingSpace($event)" autocomplete="off" autocorrect="off">
                        <div *ngIf="editMode && leadForm.get('email')?.invalid && leadForm.get('email')?.touched" class="text-danger small">
                          Valid email is required
                        </div>
                      </div>
  
                      <div class="mb-3">
                        <label class="form-label fw-bold" *ngIf="lead.category.toLowerCase() === 'entity'">Registration Number (TIN) <span class="text-danger">*</span></label>
                        <label class="form-label fw-bold" *ngIf="lead.category.toLowerCase() !== 'entity'">License Number <span class="text-danger">*</span></label>
                        <div *ngIf="!editMode" class="form-control-static">{{ lead?.tin }}</div>
                        <input *ngIf="editMode" type="text" class="form-control" formControlName="tin"
                        (input)="removeLeadingSpace($event)" autocomplete="off" autocorrect="off">
                        <div *ngIf="editMode && leadForm.get('tin')?.invalid && leadForm.get('tin')?.touched" class="text-danger small">
                          Registration number is required
                        </div>
                      </div>
  
                      <div class="mb-3" *ngIf="lead.category === 'entity'">
                        <label class="form-label fw-bold">Contact Person</label>
                        <div *ngIf="!editMode" class="form-control-static">{{ lead?.contact_person }}</div>
                        <input *ngIf="editMode" type="text" class="form-control" formControlName="contact_person"
                        (input)="removeLeadingSpace($event)" autocomplete="off" autocorrect="off">
                      </div>
  
                      <div class="mb-3">
                        <label class="form-label fw-bold">Address</label>
                        <div *ngIf="!editMode" class="form-control-static">
                          <div style="margin-bottom: 15px;">{{ lead?.address?.street }}</div>
                          <!-- <div>House/Flat No: {{ lead?.address?.house_flat_no }}</div>
                          <div>Street: {{ lead?.address?.street }}</div>
                          <div>City: {{ lead?.address?.city_town }}</div>
                          <div>State: {{ lead?.address?.state }}</div> 
                          <div>Country {{ lead?.address?.country }}</div>
                          <div>Zipcode: {{ lead?.address?.zipcode }}</div> -->
                        </div>
                        <div *ngIf="editMode" formGroupName="address">
                          <!-- <div class="row mb-2">
                            <div class="col-md-6">
                              <label class="form-label small">Address Type</label>
                              <select class="form-select form-select-sm" formControlName="address_type">
                                <option value="Home">Home</option>
                                <option value="Office">Office</option>
                                <option value="Other">Other</option>
                              </select>
                            </div>
                            <div class="col-md-6">
                              <label class="form-label small">House/Flat No</label>
                              <input type="text" class="form-control form-control-sm" formControlName="house_flat_no">
                            </div>
                          </div>
                          <div class="row mb-2">
                            <div class="col-md-6">
                              <label class="form-label small">Street</label>
                              <input type="text" class="form-control form-control-sm" formControlName="street">
                            </div>
                            <div class="col-md-6">
                              <label class="form-label small">Landmark</label>
                              <input type="text" class="form-control form-control-sm" formControlName="landmark">
                            </div>
                          </div>
                          <div class="row mb-2">
                            <div class="col-md-6">
                              <label class="form-label small">City/Town</label>
                              <input type="text" class="form-control form-control-sm" formControlName="city_town">
                            </div>
                            <div class="col-md-6">
                              <label class="form-label small">State</label>
                              <input type="text" class="form-control form-control-sm" formControlName="state">
                            </div>
                          </div> -->
                          <textarea class="form-control" style="margin-bottom: 15px;" rows="3" formControlName="street" (input)="removeLeadingSpace($event)" autocomplete="off" autocorrect="off"></textarea>
                          <!-- <div class="row mb-2">
                            <div class="col-md-6">
                              <label class="form-label fw-bold">Country</label>
                              <select class="form-select form-select-sm" formControlName="country">
                                <option *ngFor="let country of countries" [value]="country">{{ country }}</option>
                              </select>
                            </div>
                            <div class="col-md-6">
                              <label class="form-label fw-bold">Zipcode</label>
                              <input type="text" class="form-control form-control-sm" formControlName="zipcode">
                            </div>
                          </div> -->
                        </div>
                      </div>

                      <div class="mb-3">
                        <div *ngIf="!editMode" class="form-control-static">
                          <label class="form-label fw-bold">Country</label>
                          <div style="margin-bottom: 15px;">{{ lead?.address?.country }}</div>
                        </div>
                        <div *ngIf="editMode" formGroupName="address">
                          <div class="row mb-2">
                            <div class="col-md-6">
                              <label class="form-label fw-bold">Country</label>
                              <select class="form-select form-select-sm" formControlName="country">
                                <option *ngFor="let country of countries" [value]="country">{{ country }}</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="mb-3">
                        <div *ngIf="!editMode" class="form-control-static">
                          <label class="form-label fw-bold">Zipcode</label>
                          <div style="margin-bottom: 15px;">{{ lead?.address?.zipcode }}</div>
                        </div>
                        <div *ngIf="editMode" formGroupName="address">
                          <div class="row mb-2">
                            <div class="col-md-6">
                              <label class="form-label fw-bold">Zipcode</label>
                              <input type="text" class="form-control form-control-sm" formControlName="zipcode"
                              (input)="removeLeadingSpace($event)" autocomplete="off" autocorrect="off">
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>
  
                    <!-- Right Column -->
                    <div class="col-md-6">
                      <div class="mb-3">
                        <label class="form-label fw-bold">Area(s) Of Specialization <span class="text-danger">*</span></label>
                        <div *ngIf="!editMode" class="form-control-static">{{ getDisplaySubcategory(lead.subcategory) }}</div>
                        <select *ngIf="editMode" class="form-select" formControlName="subcategory">
                          <option *ngFor="let spec of specializations" [value]="spec">{{ spec }}</option>
                        </select>
                        <div *ngIf="editMode && leadForm.get('subcategory')?.invalid && leadForm.get('subcategory')?.touched" class="text-danger small">
                          Specialization is required
                        </div>
                      </div>
  
                      <div class="mb-3" *ngIf="lead.category === 'entity'">
                        <label class="form-label fw-bold">Designation</label>
                        <div *ngIf="!editMode" class="form-control-static">{{ lead?.designation }}</div>
                        <input *ngIf="editMode" type="text" class="form-control" formControlName="designation"
                        (input)="removeLeadingSpace($event)" autocomplete="off" autocorrect="off">
                      </div>
  
                      <div class="mb-3" *ngIf="lead.category === 'entity'">
                        <label class="form-label fw-bold">Number Of Lawyers</label>
                        <div *ngIf="!editMode" class="form-control-static">{{ lead?.no_of_lawyers }}</div>
                        <input *ngIf="editMode" type="number" min="0" class="form-control" formControlName="no_of_lawyers"
                        (input)="removeLeadingSpace($event);onInput($event);restrictFirstPosition($event)" 
                        (paste)="preventMinusPaste($event)" autocomplete="off" autocorrect="off">
                      </div>
  
                      <div class="mb-3">
                        <label class="form-label fw-bold">Contact Number</label>
                        <div *ngIf="!editMode" class="form-control-static">{{ lead?.contact_phone }}</div>
                        <input *ngIf="editMode" type="text" class="form-control" formControlName="contact_phone"
                        (input)="removeLeadingSpace($event)" autocomplete="off" autocorrect="off">
                        <div *ngIf="editMode && leadForm.get('contact_phone')?.invalid && leadForm.get('contact_phone')?.touched" class="text-danger small">
                          Enter a valid 10-digit number
                        </div>
                      </div>
  
                      <div class="mb-3">
                        <label class="form-label fw-bold">Status</label>
                        <div *ngIf="!editMode" class="form-control-static">{{ lead?.status }}</div>
                        <select *ngIf="editMode" class="form-select" formControlName="status">
                          <option selected value="new">New</option>
                          <option value="contacted">Contacted</option>
                          <option value="qualified">Qualified</option>
                          <option value="converted">Converted</option>
                          <option value="lost">Lost</option>
                        </select>
                      </div>
  
                      <div class="mb-3">
                        <label class="form-label fw-bold">Additional Details</label>
                        <div *ngIf="!editMode" class="form-control-static">{{ lead?.additional_info }}</div>
                        <textarea *ngIf="editMode" class="form-control" rows="3" formControlName="additional_info" (input)="removeLeadingSpace($event)" autocomplete="off" autocorrect="off"></textarea>
                      </div>
                    </div>
                  </div>
                </form>

                <div class="modal-footer justify-content-center" *ngIf="editMode">
                  <button type="button" class="btn btn-secondary" (click)="toggleEditMode()">Cancel</button>
                  <button type="button" class="btn btn-primary" (click)="saveChanges()">Save Changes</button>
                </div>

              </div>
            </div>
          </div>
          <div class="tab-pane fade" [ngClass]="{'show active': activeTab === 'timeline'}">
            <div *ngIf="activeTab === 'timeline'">
              <div class="container-fluid mb-4">
                <div class="row mb-3">
                  <div class="col">
                    <h5 class="lead-title">Lead {{ lead?.category === 'entity' ? 'Entity' : 'Lawyer' }} - {{ lead?.fullname }}</h5>
                  </div>
                  <div class="col text-end">
                    <button class="btn btn-primary btn-sm" (click)="addNewNote()">
                      <i class="bi bi-plus-circle"></i> Add New Note
                    </button>
                  </div>
                </div>
              
                <div class="timeline-wrapper">
                  <div *ngIf="lead.notes_list.length === 0" class="text-center py-5">
                    <p class="text-muted">No notes available for this lead. Click "Add New Note" to create your first note.</p>
                  </div>
                
                  <div class="timeline-grid">
                    <ng-container *ngFor="let note of lead.notes_list; let i = index">
                      <div class="timeline-card">
                        <div class="timeline-dot" [ngStyle]="{ 'background-color': colorClasses[0] || '#ccc' }"></div>
                        <div class="note-card">
                          <div class="note-header">
                            <div class="note-date">{{ note.add_on | date:'MMMM d, y' }}</div>
                            <div class="note-title">{{note.notes}}</div>
                          </div>
                          <div class="note-description">
                            {{note.content}}
                          </div>
                          <div class="note-footer">Added by {{ note.added_by }}</div>
                        </div>
                      </div>
                    </ng-container>
                  </div>
                </div>
                
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</div>